/*
 * svnty-colour-gallery.js — THE TRUE SWATCH, the gallery half (R120 / D2-17, 2026-09-20).
 * A merged product carries every colour's images in one media list; the catalogue alt of each image is
 * "{Title} {dash} {Colour} {dash} SVNTY, view n of N" (written by the consolidation). The page never prints that dash (D5-1,
 * A-07, NO DASH): snippets/product-thumbnail.liquid reads the colour server side into data-svnty-colour, and this file
 * reads only that attribute ("" = an untagged picture, never hidden). On load and on every variant change
 * the gallery shows only the selected colour's images, the counter says n of THAT colour's total, and the first
 * image of the colour becomes active. Products without a Colour option are untouched. Classic deferred asset.
 * THE COLOUR PIPELINE (D4-25): the gallery is a subscriber of the bus (assets/svnty-colour.js): it follows 'svnty:colour'
 * and never listens to the picker itself. Trade's variantChange is still heard, but only because Trade re-sorts the
 * media list after its fetch; the gallery then re-applies the bus's colour (get()), it never reads a new one there.
 * After each filter it announces 'svnty:gallery:filtered' (the pill's recount and THE ROW LAW's hero measure wait on it).
 */
(function () {
  'use strict';
  if (window.__svntyColourGalleryInit) return;
  window.__svntyColourGalleryInit = true;

  function colourOf(section) {
    var sel = section.querySelector('variant-selects');
    if (!sel) return null;
    var fs = Array.prototype.slice.call(sel.querySelectorAll('fieldset, .product-form__input'));
    for (var i = 0; i < fs.length; i++) {
      var name = (fs[i].getAttribute('data-svnty-option') || '').toLowerCase();
      if (name.indexOf('colour') < 0 && name.indexOf('color') < 0) continue;
      var checked = fs[i].querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var select = fs[i].querySelector('select');
      if (select) return select.value;
    }
    return null;
  }

  function busColour() {
    try { return (window.SVNTY && window.SVNTY.colour) ? window.SVNTY.colour.get().colour : null; } catch (e) { return null; }
  }

  /* the variant's featured slide (Trade puts it first after its fetch), when the bus names a variant */
  function featuredSlide(section, variantId) {
    if (!variantId) return null;
    var sel = section.querySelector('variant-selects'); if (!sel) return null;
    var data = [];
    try { data = typeof sel.getVariantData === 'function' ? sel.getVariantData() : JSON.parse(sel.querySelector('[type="application/json"]').textContent); } catch (e) { return null; }
    var v = null;
    for (var i = 0; i < data.length; i++) { if (String(data[i].id) === String(variantId)) { v = data[i]; break; } }
    if (!v || !v.featured_media || !v.featured_media.id) return null;
    return section.querySelector('.product__media-item[data-media-id$="-' + v.featured_media.id + '"]');
  }

  /* filter(): only the colour's slides show; returns the visible slides in DOM order */
  function filter(section, colour) {
    var items = Array.prototype.slice.call(section.querySelectorAll('.product__media-item'));
    if (!items.length) return [];
    var shown = [];
    items.forEach(function (item) {
      var tag = item.querySelector('[data-svnty-colour]');
      var c = (tag && tag.getAttribute('data-svnty-colour')) || '';
      var match = !c || c === colour;               /* an untagged picture is never hidden */
      item.classList.toggle('svnty-colour-hidden', !match);
      if (match) shown.push(item);
    });
    if (!shown.length) { items.forEach(function (i) { i.classList.remove('svnty-colour-hidden'); }); return items; }
    var total = section.querySelector('.slider-counter--total');
    if (total) total.textContent = String(shown.length);
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.thumbnail-list__item'));
    thumbs.forEach(function (t) {
      var btn = t.querySelector('[data-target]');
      var target = btn && btn.getAttribute('data-target');
      var item = target && section.querySelector('[data-media-id="' + target + '"]');
      t.classList.toggle('svnty-colour-hidden', !!(item && item.classList.contains('svnty-colour-hidden')));
    });
    return shown;
  }

  /* THE JUMP (03:08, iPhone: "the hero scrolls through a different colour, then comes to the selected one; nothing
     scrolls left or right"): a colour change never animates the carousel. In ONE task, before any paint: the slides flip,
     the colour's first picture (the variant's featured one, which Trade will put first after its fetch, so its later
     re-sort finds nothing visible to move) goes to the front, the list's smooth scrolling is held off, scrollLeft lands
     on it, the active slide and the counter say 1 of the colour, and THE ROW LAW re-levels the hero. The hold lasts until
     Trade's own variantChange (its setActiveMedia scrolls to the same slide, instantly) plus two frames. Trade's smooth
     path stays for the shopper's own thumb, arrow and thumbnail moves. */
  /* reorder(list, kids, ordered): the fewest moves (A-05, D5-1). WebKit pays about 3 ms for every <li> re-inserted (39 moved
     = 101 ms of a colour tap on the iPhone); the slides already in the right relative order (the longest increasing run of
     their target positions) stay, only the others move: after a colour change that is the old front slide and the new one,
     two moves. The final order is exactly the full sort's, so Trade's re-sort and the viewer's order read the same DOM. */
  function reorder(list, kids, ordered) {
    var want = new Map(); ordered.forEach(function (li, k) { want.set(li, k); });
    var seq = kids.map(function (li) { return want.get(li); }), n = seq.length;
    var len = [], prev = [], best = -1;
    for (var i = 0; i < n; i++) {
      len[i] = 1; prev[i] = -1;
      for (var j = 0; j < i; j++) if (seq[j] < seq[i] && len[j] + 1 > len[i]) { len[i] = len[j] + 1; prev[i] = j; }
      if (best < 0 || len[i] > len[best]) best = i;
    }
    var keep = new Set();
    for (var k = best; k >= 0; k = prev[k]) keep.add(kids[k]);
    var tail = kids[kids.length - 1].nextSibling;
    for (var m = ordered.length - 1; m >= 0; m--) {
      var li = ordered[m];
      if (keep.has(li)) continue;
      var before = m + 1 < ordered.length ? ordered[m + 1] : tail;
      if (li.nextSibling !== before) list.insertBefore(li, before);
    }
  }

  var holdToken = 0;
  function jump(section, shown, variantId) {
    var target = featuredSlide(section, variantId);
    if (!target || shown.indexOf(target) < 0) target = shown[0];
    if (!target) return;
    var list = target.parentElement;
    /* Trade's own order after its fetch: the variant's picture first, then Shopify's media order (data-svnty-pos, printed
       by snippets/product-media-gallery.liquid), so the fetch's re-sort finds every slide already in place */
    var kids = Array.prototype.filter.call(list.children, function (li) { return li.classList.contains('product__media-item'); });
    var ordered = kids.every(function (li) { return li.hasAttribute('data-svnty-pos'); })
      ? [target].concat(kids.filter(function (li) { return li !== target; }).sort(function (a, b) { return (+a.getAttribute('data-svnty-pos')) - (+b.getAttribute('data-svnty-pos')); }))
      : [target].concat(kids.filter(function (li) { return li !== target; }));
    var same = ordered.every(function (li, k) { return kids[k] === li; });
    if (!same) reorder(list, kids, ordered);
    var token = ++holdToken;
    list.style.scrollBehavior = 'auto';
    list.scrollLeft = 0;
    Array.prototype.forEach.call(section.querySelectorAll('.product__media-item'), function (i) { i.classList.toggle('is-active', i === target); });
    var sc = list.closest('slider-component');
    try { if (sc && sc.resetPages) sc.resetPages(); } catch (e) {}
    var cur = section.querySelector('.slider-counter--current'); if (cur) cur.textContent = '1';
    var tot = section.querySelector('.slider-counter--total'); if (tot) tot.textContent = String(shown.length);
    try { if (window.SVNTY && window.SVNTY.rows && window.SVNTY.rows.measureHero) window.SVNTY.rows.measureHero(); } catch (e) {}
    function release() {
      if (token !== holdToken) return;
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (token === holdToken) list.style.scrollBehavior = ''; }); });
    }
    list.__svntyRelease = release;
    setTimeout(release, 2500);   /* no fetch answer (an unavailable combination): let go anyway */
  }

  /* apply(section, colour, variantId, doJump): filter, then either jump (a colour change, the first paint) or only keep
     the active slide visible (Trade's re-sort after a size pick: never move the shopper's picture) */
  function apply(section, colourGiven, variantId, doJump) {
    var colour = colourGiven || busColour() || colourOf(section);
    if (!colour) return;
    var shown = filter(section, colour);
    if (!shown.length) return;
    if (doJump) jump(section, shown, variantId);
    else {
      var active = section.querySelector('.product__media-item.is-active');
      if (!active || active.classList.contains('svnty-colour-hidden')) jump(section, shown, variantId);
    }
    document.dispatchEvent(new CustomEvent('svnty:gallery:filtered', { detail: { colour: colour } }));
  }

  /* the product page's own gallery only: a quick-add modal's gallery is another product's and never follows this page */
  function applyAll(colour, variantId, doJump) {
    document.querySelectorAll('section[id^="MainProduct-"]').forEach(function (m) {
      var r = m.closest('.shopify-section') || m;
      if (r.querySelector('.product__media-item')) apply(r, colour, variantId, doJump);
    });
  }

  /* THE STILL SIZE (2026-09-25: "nothing scrolls left or right"): a pick in the picker that keeps the colour (a
     size) must never move the hero. Trade answers every variant change with setActiveMedia(featured), which scrolls the
     carousel back to the variant's first picture; while such a same-colour change is in flight (from its change event to
     two frames after Trade's variantChange), that call on the product's own gallery is ignored, so the shopper stays on
     the slide they are on and the counter keeps its number. The capture phase reads the picker before the bus has spoken,
     so "the colour is unchanged" is judged against the colour already on screen. Trade's thumbnails bound the original
     method at construction, so the shopper's own thumbnail taps are never intercepted. */
  var sizeHold = 0;
  function holdGallery() {
    document.querySelectorAll('section[id^="MainProduct-"] media-gallery').forEach(function (g) {
      if (g.__svntyStill) return;
      var orig = g.setActiveMedia;
      if (typeof orig !== 'function') return;          /* not upgraded yet: media-gallery.js runs after this file */
      g.__svntyStill = true;
      g.setActiveMedia = function () { if (sizeHold) return; return orig.apply(this, arguments); };
    });
  }

  var lastColour = null;
  function init() {
    holdGallery();
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('media-gallery').then(function () { holdGallery(); });
    document.addEventListener('DOMContentLoaded', holdGallery);
    document.addEventListener('change', function (e) {
      var m = document.querySelector('section[id^="MainProduct-"] variant-selects');
      if (!m || !e.target || !m.contains(e.target)) return;
      var now = busColour();
      if (!now || now !== lastColour) return;          /* a colour change: THE JUMP handles it */
      var token = ++sizeHold;
      setTimeout(function () { if (sizeHold === token) sizeHold = 0; }, 4000);   /* no fetch answer: let go */
    }, true);
    /* the first paint: the server rendered every colour's slides; the selected colour's show at once */
    applyAll(null, null, false);
    lastColour = busColour();
    /* THE BUS: a colour change (from the buy box, the sticky bar, a card, anywhere) filters and JUMPS the gallery */
    document.addEventListener('svnty:colour', function (e) {
      var d = e.detail || {};
      var changed = d.colour !== lastColour; lastColour = d.colour;
      applyAll(d.colour, d.variantId, changed && d.source !== 'load');
    });
    /* Trade re-sorted the media after its fetch: re-apply the bus's colour (not a colour source), then let the hold go */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        if (sizeHold) { var t = sizeHold; requestAnimationFrame(function () { requestAnimationFrame(function () { if (sizeHold === t) sizeHold = 0; }); }); }
        applyAll(null, null, false);
        document.querySelectorAll('section[id^="MainProduct-"] .product__media-list').forEach(function (l) { if (l.__svntyRelease) l.__svntyRelease(); });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
